'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@headlessui/react';
import { BrightcovePlayerAutoplay } from './BrightcovePlayer';
interface VideoPlayerModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  accountId?: string;
  playerId?: string;
  autoplay?: boolean;
}
export const VideoPlayerModal = t0 => {
  const $ = _c(18);
  const {
    isOpen,
    onClose,
    videoId,
    accountId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = typeof window !== "undefined" ? window : {
      innerWidth: 480,
      innerHeight: 360
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    innerWidth,
    innerHeight
  } = t1;
  const baseDimension = Math.min(innerWidth / 16, innerHeight / 9) * 0.9;
  const height = baseDimension * 9;
  const width = baseDimension * 16;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="fixed inset-0 bg-bodi-black-text" aria-hidden="true" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = () => {
      onClose();
    };
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M0.292492 0.305288C0.479831 0.117817 0.733884 0.0125018 0.998781 0.0125018C1.26368 0.0125018 1.51773 0.117817 1.70507 0.305288L5.99375 4.59829L10.2824 0.305288C10.3746 0.209778 10.4848 0.133596 10.6067 0.0811869C10.7286 0.0287779 10.8597 0.00119157 10.9923 3.77571e-05C11.125 -0.00111606 11.2565 0.0241854 11.3793 0.0744663C11.5021 0.124747 11.6136 0.199 11.7074 0.292893C11.8012 0.386786 11.8754 0.498438 11.9256 0.621334C11.9758 0.744231 12.0011 0.87591 12 1.00869C11.9988 1.14147 11.9713 1.27269 11.9189 1.39469C11.8665 1.5167 11.7904 1.62704 11.695 1.71929L7.40633 6.01229L11.695 10.3053C11.877 10.4939 11.9777 10.7465 11.9754 11.0087C11.9731 11.2709 11.8681 11.5217 11.6828 11.7071C11.4976 11.8925 11.2471 11.9977 10.9851 12C10.7232 12.0022 10.4709 11.9014 10.2824 11.7193L5.99375 7.42629L1.70507 11.7193C1.51666 11.9014 1.26431 12.0022 1.00238 12C0.740443 11.9977 0.489883 11.8925 0.304661 11.7071C0.11944 11.5217 0.0143761 11.2709 0.0121 11.0087C0.00982384 10.7465 0.110517 10.4939 0.292492 10.3053L4.58118 6.01229L0.292492 1.71929C0.10521 1.53176 0 1.27745 0 1.01229C0 0.747124 0.10521 0.492816 0.292492 0.305288Z" fill="white" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="absolute top-3 right-3 lg:top-6 lg:right-6 lg:scale-150"><button onClick={t3}>{t4}</button></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: `${width}px`,
      height: `${height}px`
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== accountId || $[9] !== videoId) {
    t7 = <Dialog.Panel className="flex w-full items-center justify-center rounded px-5 py-10"><div className="relative" style={t6}><BrightcovePlayerAutoplay videoId={videoId} accountId={accountId} autoplay={true} isMuted={false} /></div></Dialog.Panel>;
    $[8] = accountId;
    $[9] = videoId;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className="fixed inset-0 flex w-screen items-center justify-center p-4">{t5}{t7}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isOpen || $[15] !== onClose || $[16] !== t8) {
    t9 = <Dialog open={isOpen} onClose={onClose} className="relative z-50">{t2}{t8}</Dialog>;
    $[14] = isOpen;
    $[15] = onClose;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};